/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-09-19 10:25:05
 * @LastEditTime: 2025-04-29 17:36:26
 * @LastEditors: didan
 */
import { asyncRoutes, constantRoutes } from '@/router';
import { getAllByGroupId } from '@/api/common';
import { checkCurrentBusinessPermission } from '@/config/waybill-data-whitelist';

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}
function removeTypeObjects(node) {
  if (!node.children) return;

  node.children = node.children.filter(child => child.pattern !== 'account');

  for (const child of node.children) {
    removeTypeObjects(child);
  }
}

const state = {
  routes: [],
  addRoutes: [],
  AllByGroup: {},
  groupConfig: {},
};

const mutations = {
  SET_ALLGROUP: (state, mobile) => {
    state.AllByGroup = mobile;
  },
  SET_GROUPCONFIG: (state, mobile) => {
    state.groupConfig = mobile;
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    const arr = [];
    const routeArr = constantRoutes.concat(routes);
    const isAiWrite = localStorage.getItem('isAiWrite');

    // 检查当前企业是否有运单数据访问权限
    const hasWaybillDataPermission = checkCurrentBusinessPermission();

    routeArr.forEach(item => {
      if (item.name == 'intellRecord') {
        item.hidden = isAiWrite == 'false' ? true : false;

        // 控制运单数据子菜单的显示
        if (item.children && Array.isArray(item.children)) {
          item.children.forEach(child => {
            if (child.name === 'waybillData') {
              child.hidden = !hasWaybillDataPermission;
            }
          });
        }
      }
    });
    for (const val in state.AllByGroup) {
      arr.push(state.AllByGroup[val]);
    }
    const pattern = arr.some(item => {
      return item.account_mode.status && item.account_mode.status == 1;
    });
    if (!pattern) {
      for (const item of routeArr) {
        removeTypeObjects(item);
      }
    }
    if (state.groupConfig.account_detail.status && state.groupConfig.account_detail.status == 2) {
      routeArr.splice(
        routeArr.findIndex(item => item.name == 'Accounts'),
        1,
      );
    }
    state.routes = routeArr;
  },
  // SET_IS_PERMISSION: (state, status) => {
  //   state.isPermission = status;
  // },
};

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(async resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  getSetting({ commit, state }) {
    return new Promise((resolve, reject) => {
      getAllByGroupId()
        .then(response => {
          console.log('permisssion-getAllByGroupId');
          const { data } = response;
          if (data.groupConfig) {
            commit('SET_GROUPCONFIG', data.groupConfig);
          }
          delete data.groupConfig;
          commit('SET_ALLGROUP', data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // getIsPermissionAI({ commit }) {
  //   return new Promise(async resolve => {

  //     console.log(data, '12222');
  //     commit('SET_IS_PERMISSION', data.permission);
  //     resolve(data.permission);
  //   });
  // },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
